export default "__VITE_ASSET__42fbf7f7__"